import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Read more: terra.vts.com/process/overview
import { useCallback } from "react";
import { FormattedInput } from "./FormattedInput";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { CalendarIcon } from "../icons";
import classNames from "classnames";
import { Calendar } from "./Calendar/Calendar";
import { Popover } from "../Popover";
import { FOCUS_VISIBLE_OUTLINE } from "../../utils/css-helpers";
dayjs.extend(localizedFormat);
const isValid = (value) => dayjs(value).isValid();
const asString = (value) => dayjs(value).format("YYYY-MM-DD");
export const DateInput = (props) => {
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : "medium";
    const format = useCallback((value) => {
        return isValid(value)
            ? dayjs(value)
                .locale(props.locale || "en-us")
                .format("L")
            : "";
    }, [props.locale]);
    const parse = useCallback((value) => {
        if (!value) {
            return null;
        }
        return dayjs(value)
            .locale(props.locale || "en-us")
            .toDate();
    }, [props.locale]);
    const handleDaySelect = (day, event) => {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, { event, parsed: day, value: asString(day) });
    };
    const iconClasses = [
        "appearance-none",
        "absolute",
        "right-1",
        "top-0",
        "leading-4",
        FOCUS_VISIBLE_OUTLINE,
        size === "small" && "top-[3px]",
        size === "medium" && "top-0.75",
        size === "large" && "top-[10px]",
    ];
    const iconSize = size === "large" ? "md" : "sm";
    return (_jsx(FormattedInput, Object.assign({}, props, { format: format, parse: parse, isValid: isValid, asString: asString, render: ({ children }) => {
            const parsedValue = parse(props.value);
            const value = dayjs(parsedValue).isValid() ? parsedValue : undefined;
            return (_jsxs("div", { className: "relative", children: [children, _jsx(Popover, { withArrow: true, initialFocus: false, placement: props.calendarPlacement, trigger: _jsx("button", { disabled: props.isReadonly || props.isDisabled, className: classNames(iconClasses), type: "button", children: _jsx(CalendarIcon, { color: "text-subdued", size: iconSize }) }), content: ({ close }) => (_jsx(Calendar, { value: value !== null && value !== void 0 ? value : undefined, onDayClick: (day, _activeModifiers, e) => {
                                handleDaySelect(day, e);
                                close();
                            }, onDayKeyDown: (day, _activeModifiers, e) => {
                                if (e.key !== "Space") {
                                    return;
                                }
                                handleDaySelect(day, e);
                                close();
                            } })) })] }));
        } })));
};
//# sourceMappingURL=DateInput.js.map